module.exports = __webpack_public_path__ + "assets/img/noVIP.d10ab616.png";